import type { ReactNode } from "react";
import { motion } from "motion/react";
import { cx } from "class-variance-authority";

import { Typography } from "../Typography/Typography";
import * as styles from "./PageMessage.module.scss";

type PageMessageProps = {
  title: string;
  subTitle?: string | ReactNode;
  children?: ReactNode;
  image?: ReactNode;
  className?: string;
  contentClassName?: string;
};

const PageMessage = ({
  title,
  subTitle,
  children,
  image,
  className,
  contentClassName,
}: PageMessageProps) => {
  return (
    <div className={cx(styles.container, className)}>
      {image ? image : null}
      <motion.div
        initial={{ opacity: 0, y: 5 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.1 }}
      >
        <Typography className={styles.title} variant="h3" noSpacing>
          {title}
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 5 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.2 }}
      >
        {subTitle && typeof subTitle === "string" ? (
          <Typography className={styles.subTitle} variant="body" noSpacing>
            {subTitle}
          </Typography>
        ) : (
          <div className={styles.subTitle}>{subTitle}</div>
        )}
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 5 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.3 }}
      >
        <div className={cx(styles.content, contentClassName)}>{children}</div>
      </motion.div>
    </div>
  );
};

export { PageMessage };
